// Catalog.ID Client — Device API
// ============================================================================

import { api } from './client';
import type {
    DeviceSetupRequest, DeviceSetupResponse, DeviceResetRequest,
    DeviceUnlockRequest, DeviceUnlockResponse,
    ChangePinRequest, RemoveDeviceRequest,
    DeviceInfo, UpdateDeviceLabelRequest,
} from './types';

export async function setupDevice(req: DeviceSetupRequest): Promise<DeviceSetupResponse> {
    return api.post('/api/device/setup', req);
}

export async function unlockDevice(req: DeviceUnlockRequest): Promise<DeviceUnlockResponse> {
    return api.post('/api/device/unlock', req);
}

export async function changePin(req: ChangePinRequest): Promise<void> {
    return api.put('/api/device/pin', req);
}

export async function resetDevice(req: DeviceResetRequest): Promise<DeviceSetupResponse> {
    return api.post('/api/device/reset', req);
}

export async function removeDevice(req: RemoveDeviceRequest): Promise<void> {
    return api.del('/api/device', req);
}

/**
 * Remove one identity's device record on this browser, authenticated with THAT
 * identity's session token. Used by "Forget this device", which de-enrols every
 * identity stored here, not just the active one.
 */
export async function removeDeviceWithToken(deviceToken: string, sessionToken: string, cid: string): Promise<void> {
    return api.del('/api/device', { deviceToken } satisfies RemoveDeviceRequest, { token: sessionToken, cid });
}

export async function listDevices(): Promise<DeviceInfo[]> {
    return api.get('/api/device');
}

export async function removeDeviceById(deviceId: number): Promise<void> {
    return api.del(`/api/device/${deviceId}`);
}

/** Rename a device. 404 when the device is not the caller's. */
export async function updateDeviceLabel(deviceId: number, req: UpdateDeviceLabelRequest): Promise<void> {
    return api.put(`/api/device/${deviceId}/label`, req);
}
